import { IFansUnitedDataLabels } from '../../../../types/common';

interface IFansUnitedToggleTitleProps {
  title?: IFansUnitedDataLabels['fu_play_free'];
}

export const FansUnitedToggleTitle = ({ title }: IFansUnitedToggleTitleProps): JSX.Element => {
  if (!title) {
    return (
      <>
        Play <span style={{ color: '#FF901A', fontWeight: 'bold' }}>FREE</span> with Sportal
      </>
    );
  }

  return <>{title}</>;
};
